import slideFnc from './slide_fnc.js';

/**
 * アコーディオン
 * @constructor
 * @author ERINA MORISAKI
 */
class Accordion {
  /**
   * @param {string} this.addClassNameval 付与するクラス名。
   * @param {object} this.slideFnc 使用するモジュールの機能。今回使用しているのはスライドアップ、ダウンの機能。
   * @param {object} this._optionInit オプション。
   * @param {string} this._optionInit.triggerClassName トリガーの対象となるクラス名。
   * @param {number} this._optionInit.slideTime アニメーションする時間の指定。
   * @param {boolean} this._optionInit.toggleFlg トグル機能を使用するか判定するフラグ。使用する際はtrue。不使用な際は省略。
   * @param {boolean} this._classFlag トリガーとなるclassが存在するか判定するフラグ。
   */
  constructor(option) {
    this._addClassNameval = 'is-open';
    this._slideFnc = slideFnc;
    this._optionInit = {
      triggerClassName: '.js-accordion-trigger',
      slideTime: '400',
      toggleFlg: false,
    };

    if (option) {
      // インスタンス化時にoptionが設定されていた場合
      this._optionInit = Object.assign(this._optionInit, option);
    }

    this._classFlag = !!document.querySelector(this._optionInit.triggerClassName);

    this.init();
  }

  init() {
    if (this._classFlag) {
      this.accordion(this._optionInit.triggerClassName, this._optionInit.toggleFlg);
    }
  }

  accordion(element, style) {
    const slideToggleBtn = document.querySelectorAll(element);
    slideToggleBtn.forEach((accordionTrigger, index) => {
      accordionTrigger.addEventListener('click', (e) => {
        const indexNum = index;

        // data-target属性が存在するかチェック
        const dataTarget = e.currentTarget.getAttribute('data-target');
        if (dataTarget) {
          // .js-値 形式のクラス名を作成し、それをターゲットにアコーディオンを適用
          const targetElement = document.querySelector(`.js-${dataTarget}`);
          if (targetElement) {
            this._slideFnc.slideToggle(targetElement, this._optionInit.slideTime);
            e.currentTarget.classList.toggle(this._addClassNameval);
          }
        } else {
          // 通常のアコーディオン処理
          this._slideFnc.slideToggle(e.currentTarget.nextElementSibling, this._optionInit.slideTime);
          e.currentTarget.classList.toggle(this._addClassNameval);
        }

        if (style) {
          slideToggleBtn.forEach((el, idx) => {
            if (idx !== indexNum) {
              this._slideFnc.slideUp(el.nextElementSibling, this._optionInit.slideTime);
              el.classList.remove(this._addClassNameval);
            }
          });
        }
      });
    });
  }
}

export default Accordion;
